export default __webpack_public_path__ + "static/feature-dropmaps-950a8b10b090f1e5eca84cd1cbb1cf34.png";